import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { IndexingApiService } from '../services/indexing-api.service';
import { SiteApiService } from '../services/site-api.service';

@Component({
  selector: 'app-indexing-history',
  templateUrl: './indexing-history.component.html',
  styleUrls: ['./indexing-history.component.css']
})
export class IndexingHistoryComponent {
  indexingHistories: any;
  siteName: any;
  url = "";
  favIconUrl = "";
  dataTable: any;
  currentPage: number = 1;
  totalData: number = 0;
  totalPages: number = 0;
  siteId: any;
  showSpinner = true;
  statusFilter = 2;
  autoSubmissionFilter = 0;
  urlFilter = "";

  constructor(private indexingApi: IndexingApiService,
    private route: ActivatedRoute,
    private router: Router,
    private siteApiService: SiteApiService,
    private titleService: Title) {
    this.titleService.setTitle("Indexing History | Rankahead.app");
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.siteId = params['siteId'];

      this.siteApiService.getSite(this.siteId).subscribe((site: any) => {
        
        this.siteName = site.url;
        this.favIconUrl = site.favIconUrl;

        this.changePage(1);
      }, (error: any) => {
        debugger;
        if (error?.status==404) {
          this.router.navigateByUrl("/page-not-found");
        }
      })
    });
  }

  resetFilters() {
    this.urlFilter = "";
    this.statusFilter = 2;
    this.autoSubmissionFilter = 0;

    this.changePage(1);
  }

  changePage(currentPage: any) {
    this.showSpinner = true;

    this.indexingApi.getIndexingHistory(currentPage, this.siteId, this.urlFilter, this.statusFilter, this.autoSubmissionFilter).subscribe((response: any) => {
      this.favIconUrl = response.siteImageUrl;
      this.indexingHistories = [];
      this.currentPage = currentPage;
      this.totalData = response.queryCount;
      this.totalPages = Math.ceil(response.totalCount / 50);

      // Get the pathname for URL
      for (var i = 0; i < response.indexingHistories.length; i++) {
        try {
          response.indexingHistories[i].url = new URL(response.indexingHistories[i].url)?.pathname;
        } catch (e) {
        }
      }

      this.indexingHistories = response.indexingHistories;
      this.showSpinner = false;
    })
  }
}
